module.exports = __webpack_public_path__ + "img/side-icon-14-off.837267e2.svg";